"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationPopup = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("../Button/Button");
const Popover_1 = require("./Popover");
function ConfirmationPopup({ align, anchor, children, content, open, title, onCancel, onConfirm, }) {
    const Component = anchor ? Popover_1.PopoverAnchor : Popover_1.PopoverTrigger;
    return (react_1.default.createElement(Popover_1.Popover, { open: open },
        react_1.default.createElement(Component, null, children),
        react_1.default.createElement(Popover_1.PopoverContent, { align: align, onEscapeKeyDown: onCancel },
            react_1.default.createElement("div", { className: " tw-box-border tw-flex tw-min-w-72 tw-max-w-80 tw-flex-col tw-gap-1 tw-px-4 tw-py-3" },
                react_1.default.createElement("h4", { className: "tw-text-primaryDim-400" }, title),
                react_1.default.createElement("p", null, content)),
            react_1.default.createElement("div", { className: "tw-h-px tw-bg-neutral-100" }),
            react_1.default.createElement("div", { className: "tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-3" },
                react_1.default.createElement(Button_1.Button, { onClick: onConfirm }, "Yes"),
                react_1.default.createElement(Button_1.Button, { color: "tertiary", onClick: onCancel }, "No")))));
}
exports.ConfirmationPopup = ConfirmationPopup;
